import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { IQuotationRetail } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { INumberFieldSpecs } from 'libraries/module/formbuilder/fields/number/INumberFieldSpecs';
import { formatNumber } from "@angular/common";

@Component({
    selector: 'td-adjustment',
    template: `
        <ng-template #template>
            <td mat-cell
                class="adjustment {{parity}}"
                (click)="focusField()"
                #cell
                [class.is-editable]="isEditable"
                [class.negative]="operator === '-' && hasAdjustment"
                [class.strong]="strong"
                [ngStyle]="style">
                <span *ngIf="!price || (!price.adjustment) || (!price.adjustment.value && price.adjustment.value !== 0)">-</span>
                <div *ngIf="price && price.adjustment && (price.adjustment.value || price.adjustment.value === 0)"
                     class="container">
                    <div class="operator">{{operator}}</div>
                    <div>{{value}}</div>
                </div>

                <input type="text"
                       (focus)="setEdit()"
                       #focuser
                       class="focuser"
                       *ngIf="price && isEditable">
            </td>
        </ng-template>
    `,
    styles: [ `
        :host {
            display: none
        }

        td.adjustment {
            font-size: 1rem;
            color: #414141;
            padding: .75rem;
            font-weight: normal;
            text-align: right;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
        }

        td.is-editable {
            border-right: 1px solid rgba(189, 195, 199, 0.3);
            border-bottom: 1px solid rgba(189, 195, 199, 0.3);
            cursor: text;
        }

        td.is-editable.odd {
            background: #f9fafc;
        }

        td.is-editable.even {
            background: #fefefe;
        }

        td:not(.is-editable).odd {
            background: #ecedef;
        }

        td:not(.is-editable).even {
            background: #f1f1f1;
        }

        td.negative {
            background-color: #f2dede;
            color: #a94442;
        }

        .container {
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-end;
        }

        .operator {
            margin-right: .25rem;
        }

        .focuser {
            opacity: 0;
            width: 0;
            height: 0;
            position: absolute;
            z-index: -10;
        }

        td.strong {
            font-weight: bold;
        }
    ` ],
})

export class TdAdjustmentComponent implements OnInit, OnChanges {
    @Input()
    public fieldConfig: INumberFieldSpecs;
    @Input()
    public colspan: number = 1;
    @Input()
    public price: IQuotationRetail;
    @Input()
    public isSticky: boolean;
    @Input()
    public leftPosition: number;
    @Input()
    public quotationCurrency: string = "EUR";
    @Input()
    public parity: "odd" | "even" = "odd";
    @Input()
    public isEditable: boolean = false;
    @Input()
    public forceFocus: boolean;
    @Input()
    public strong: boolean;

    @Output()
    public readonly onFocus: EventEmitter<boolean> = new EventEmitter<boolean>();

    public operator: '+' | '-' = '+';
    public hasAdjustment: boolean;
    public value: string;
    public style: { [key: string]: string } = {};

    @ViewChild('cell')
    public cell: ElementRef;
    @ViewChild('focuser')
    public focuser: ElementRef;

    @ViewChild('template', {read: TemplateRef, static: true})
    private readonly template: TemplateRef<{}>;


    constructor(
        private readonly viewContainerRef: ViewContainerRef,
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
        setTimeout(() => this.stickCell());
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.forceFocus && changes.forceFocus.currentValue && this.focuser) {
            this.focuser.nativeElement.focus();
        }

        if (changes && changes.price && changes.price.currentValue) {
            this.hasAdjustment = Boolean(
                changes.price.currentValue.adjustment &&
                (changes.price.currentValue.adjustment.value || changes.price.currentValue.adjustment.amount === 0));
            this.operator = Math.sign(changes.price.currentValue.adjustment && changes.price.currentValue.adjustment.amount) >= 0 ? "+" : "-";
            this.value = changes.price.currentValue.adjustment ? formatNumber(Math.abs(changes.price.currentValue.adjustment.amount), 'fr') : "-";
        }
        if (changes && changes.leftPosition && changes.leftPosition.currentValue) {
            this.style.left = `${changes.leftPosition.currentValue}px`;
        }

    }

    public focusField(): void {
        if (this.price && this.isEditable && this.focuser) {
            this.focuser.nativeElement.focus();
        }
    }


    public setEdit(): void {
        this.onFocus.emit(true);
    }

    private stickCell(): void {
        if (this.isSticky) {
            const left: number = this.cell.nativeElement.offsetLeft;
            this.cell.nativeElement.style.zIndex = "1";
            this.cell.nativeElement.style.left = `${left}px`;
            this.cell.nativeElement.style.position = "sticky";
        }
    }
}
